import { Modal, Pressable, Platform, StyleSheet, Text, TextInput, View, Image } from "react-native"
import { ScreenCloseModal, ScreenLeftCloseModal } from "../../components/ScreenModal"
import { MainNavProps } from "../navigation/main/MainParamList"
import { useCallback, useEffect, useState } from "react"
import { CommonBottomModal } from "../CommonBottomModal"
import { ColorGrey, ColorLine, color_333333, color_999999, color_BEBEBE, color_EDEEF1, color_main, white } from "../../assets/style/colors"
import { ButtonView } from "../../components/ButtonView"
import { hideLoading, showLoading } from "../../components/Loading"
import { showDialog } from "../../components/CommonDialog"
import globalEventBus from "../../utils/EventBus"
import { showToast } from "../../components/Toast"
import { User } from "../../../imsdk/db/t_user"
import * as ImSdk from "../../../imsdk/api";
import { useIsFocused } from "@react-navigation/native"
import {
    Str_Add,
    Str_AddFail,
    Str_AddSucc,
    Str_ChangeFail,
    Str_ChangeSuc,
    Str_Delete,
    Str_DeleteFail,
    Str_DeleteLabel,
    Str_DeleteLabelTip,
    Str_Deleted,
    Str_NowLabelMemberEmpty,
    Str_SelectFriend,
    Str_ShiftOut,
    Str_ShiftOutFail,
    Str_ShiftOutSucc,
    Str_UpdateLabelName,
} from "../../language/string_res";
import { AddEvent, DelEvent, UpdateLabelEvent } from "./ContactsLabelScreen"
import { TopicUserListContentRender } from "../Chat/TopicUsers"
import MoreIcon from "../../assets/svg/icon_more.svg";

export const LabelDetailScreen = ({ navigation, route }: MainNavProps<'LabelDetailScreen'>) => {
    const [label, setLabel] = useState(route.params.label)
    const [users, setUsers] = useState(route.params.users ?? [])
    const [modalVis, setModalVis] = useState(false)
    const [modalVis1, setModalVis1] = useState(false)

    const isFoused = useIsFocused()
    useEffect(() => {
        globalEventBus.on("DeleteLabel", handleDeleteLabel)
        globalEventBus.on("DelLabelUser", handleDelUser)
        globalEventBus.on("AddLabelUser", handleAddUser)
        globalEventBus.on("UpdateLabel", handleUpdateLabel)
        return () => {
            globalEventBus.off("DeleteLabel", handleDeleteLabel)
            globalEventBus.off("DelLabelUser", handleDelUser)
            globalEventBus.off("AddLabelUser", handleAddUser)
            globalEventBus.off("UpdateLabel", handleUpdateLabel)
        }
    }, [])
    useEffect(() => {
        if (isFoused) {
            ImSdk.getInstance().GetLabels(0, 1000, label).then(r => {
                if (r.labels && r.labels.length > 0) {
                    let labels = r.labels[0]
                    setUsers(labels.users || []);
                }
            })
        }
    }, [isFoused, label])


    const handleDeleteLabel = (label: string) => {

    }
    const handleUpdateLabel = (event: UpdateLabelEvent) => {
        setLabel(event.newLabel)
    }

    const handleDelUser = (event: DelEvent) => {
        const { label, uids } = event
        setUsers(prevUsers => {
            const result = prevUsers.filter(item => (!uids.includes(item.uid)));
            return result;
        });
    }

    const handleAddUser = (event: AddEvent) => {
        const { label, users } = event
        setUsers(prevUsers => {
            const updatedUsers = [...prevUsers, ...users];
            return updatedUsers;
        });
    }

    const deleteLabel = useCallback(() => {
        setModalVis1(false)
        showLoading()
        ImSdk.getInstance().DelLabel(label).then(r => {
            hideLoading()
            if (!r.error) {
                globalEventBus.emit("DeleteLabel", label)
                showDialog({
                    message: Str_Deleted,
                    onConfirm() {
                        navigation.goBack()
                    },
                })
            } else {
                showToast(r.error || Str_DeleteFail)
            }
        })
    }, [label])


    const itemClick = (item: User) => {
        navigation.navigate("ContactInfoModeal", { current: item, finishAll: true });
    }

    return (
        <ScreenLeftCloseModal title={label}
            onClose={() => navigation.goBack()}
            rightChildren={
                <Pressable onPress={() => { setModalVis(true) }}>
                    <MoreIcon />
                </Pressable>
            }>
            <View style={{ flex: 1 }}>
                {users.length > 0 ?
                    <View style={{ backgroundColor: white, flex: 1 }}>
                        <TopicUserListContentRender
                            users={users}
                            style={{ backgroundColor: white }}
                            statusHeight={0}
                            onClick={itemClick}
                            showHead={false}
                        />
                        <View style={{ backgroundColor: color_EDEEF1 }}>
                            <View style={styles.itemSpace} />
                            <View style={[styles.itemBottomContainer]}>
                                <ButtonView
                                    style={styles.itemBottomTextContainer}
                                    textStyle={styles.itemBottomText}
                                    onPress={() => navigation.navigate("AddUserModal", { label: label, users: users })}
                                    text={Str_Add} />
                                <ButtonView
                                    onPress={() => navigation.navigate("RemoveUserModal", { label: label, users: users })}
                                    style={styles.itemBottomTextContainer}
                                    textStyle={[styles.itemBottomText, { color: 'red' }]}
                                    text={Str_ShiftOut} />
                            </View>
                        </View>
                    </View>
                    :
                    <View style={styles.emptyContainer}>
                        <Text style={styles.emptyText}>{Str_NowLabelMemberEmpty}</Text>
                        <ButtonView
                            style={styles.emptyContainerButton}
                            textStyle={styles.emptyButton}
                            onPress={() => navigation.navigate("AddUserModal", { label: label, users: users })}
                            text={Str_Add} />
                    </View>}
            </View>
            <Modal transparent animationType="fade" visible={modalVis} onRequestClose={() => setModalVis(false)}>
                <Pressable style={styles.modalOverlay} onPress={() => setModalVis(false)}>
                    <Pressable style={styles.centerModalContainer} onPress={() => { }}>
                        <Pressable style={styles.centerModalOption} onPress={() => {
                            setModalVis(false)
                            navigation.navigate("UpdateLabelModal", { label: label })
                        }}>
                            <Text style={styles.centerModalText}>{Str_UpdateLabelName}</Text>
                        </Pressable>
                        <View style={styles.centerModalSeparator} />
                        <Pressable style={styles.centerModalOption} onPress={() => {
                            setModalVis1(true)
                            setModalVis(false)
                        }}>
                            <Text style={[styles.centerModalText, { color: 'red' }]}>{Str_DeleteLabel}</Text>
                        </Pressable>
                    </Pressable>
                </Pressable>
            </Modal>

            <Modal transparent animationType="fade" visible={modalVis1} onRequestClose={() => setModalVis1(false)}>
                <Pressable style={styles.modalOverlay} onPress={() => setModalVis1(false)}>
                    <Pressable style={styles.centerModalContainer} onPress={() => { }}>
                        <Text style={styles.centerModalMessage}>{Str_DeleteLabelTip}</Text>
                        <View style={styles.centerModalButtonRow}>
                            <Pressable style={styles.centerModalButton} onPress={() => setModalVis1(false)}>
                                <Text style={styles.centerModalCancelText}>取消</Text>
                            </Pressable>
                            <Pressable style={[styles.centerModalButton]} onPress={deleteLabel}>
                                <Text style={styles.centerModalDeleteText}>{Str_Delete}</Text>
                            </Pressable>
                        </View>
                    </Pressable>
                </Pressable>
            </Modal>
        </ScreenLeftCloseModal>
    )
}


const styles = StyleSheet.create({
    itemBottomTextContainer: {
        paddingHorizontal: 14,
        paddingVertical: 20,
    },
    itemSpace: {
        backgroundColor: ColorLine, height: 0.7, width: '100%'
    },
    itemBottomContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    emptyContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: white
    },
    emptyText: {
        color: color_999999,
        fontSize: 16,
    },
    emptyContainerButton: {
        backgroundColor: ColorGrey,
        borderRadius: 8,
        paddingVertical: 12,
        marginTop: 20,
        paddingHorizontal: 70
    },
    itemBottomText: {
        color: color_main,
        fontSize: 16
    },
    emptyButton: {
        color: color_333333,
        fontSize: 16,
        fontWeight: 'bold',
        fontFamily: '',
    },
    modalOverlay: {
        flex: 1,
        backgroundColor: 'rgba(0,0,0,0.4)',
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 30,
    },
    centerModalContainer: {
        width: '100%',
        maxWidth: 520,
        backgroundColor: white,
        borderRadius: 12,
        overflow: 'hidden',
    },
    centerModalOption: {
        paddingVertical: 16,
        alignItems: 'center',
        justifyContent: 'center',
    },
    centerModalText: {
        fontSize: 16,
        color: color_333333,
    },
    centerModalSeparator: {
        height: 1,
        backgroundColor: ColorLine,
    },
    centerModalMessage: {
        paddingHorizontal: 20,
        paddingVertical: 20,
        fontSize: 14,
        color: color_999999,
        textAlign: 'center',
    },
    centerModalButtonRow: {
        flexDirection: 'row',
        borderTopWidth: 1,
        borderColor: ColorLine,
    },
    centerModalButton: {
        flex: 1,
        paddingVertical: 14,
        alignItems: 'center',
        justifyContent: 'center',
    },
    centerModalCancelText: {
        color: color_333333,
        fontSize: 16,
    },
    centerModalDeleteText: {
        color: 'red',
        fontSize: 16,
        fontWeight: '600',
    },
})